import {
    Button,
    Card,
    CardContent,
    Grid,
    TextField,
    Divider,
    CircularProgress,
    Box,
    Typography,
} from "@material-ui/core";
import React from "react";
import { useSelector } from 'react-redux'
import { useStyles } from "./styles";
import axiosInstance from '../../../environment/axiosInstance'
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
// import DepartmentServices from "../../../../Departments/DepartmentServices/DepartmentServices";

function AddLicenses(props: any) {
    const classes = useStyles();
    const [licensesData, setLicensesData] = React.useState<any>([])
    const [loading, setLoading] = React.useState<any>(false)
    const [summaryModal, setSummaryModal] = React.useState<any>(false)
    const [checkoutModal, setCheckoutModal] = React.useState<any>(false)
    const [errorModal, setErrorModal] = React.useState<any>(false)
    const [summaryData, setSummaryData] = React.useState<any>({})
    // const onChangeNumber = (e:any) => {
    //     const val = e.target.value
    //     const name = e.target.name
    //     setCardDetails(prevState => ({
    //         ...prevState,
    //         [name]: val
    //     }));
    // };

    const fetchDefaultLicenses = () => {
        setLoading(true)
        axiosInstance.get(`/license/defaultLicenses`,).then((res: any) => {
            if (res.status === 200) {
                setLicensesData(res?.data?.data)
                setLoading(false)
            }
        })
            .catch((error) => {
                console.error("Error updating card as primary:", error);
            });
    }
 
    React.useEffect(() => {
        fetchDefaultLicenses()
    }, [])

    const SummaryLicenses = () => {
        setLoading(true)
        var data:any = []
        licensesData?.map((item:any) => {
            if(item?.quantity){
                var obj = {
                    licenseId:item?._id,
                    quantity:item?.quantity
                }
                data.push(obj)
            }         
        })
        axiosInstance.post(`/license/licenseSummary`,data).then((res: any) => {
            if (res.status === 200) {
                setSummaryData(res?.data?.data)
                setSummaryModal(true)
                setLoading(false)
            }
        })
            .catch((error) => {
                console.error("Error updating card as primary:", error);
            });
    }

    const confirmCheckout = () => {
        setLoading(true);
        var data:any = []
        licensesData?.map((item:any) => {
            if(item?.quantity){
                var obj = {
                    licenseId:item?._id,
                    quantity:item?.quantity
                }
                data.push(obj)
            }         
        })
    
        axiosInstance.post(`/license/licenseCheckout`, data)
          .then((res) => {
            if (res.status === 200) {
                <Alert severity="success">{res.data.message}</Alert>
              setCheckoutModal(true);
              setSummaryModal(false);
              setLoading(false);
            } else {
                <Alert severity="error">{res.data.message}</Alert>
            }
          })
          .catch((error:any) => {
            if (error.response && error.response.status === 400) {
                <Alert severity="error">{error.response.data.message}</Alert>
                setErrorModal(true);
        
            } else {
                <Alert severity="error">'An error occurred.'</Alert>
        
            }
            setErrorModal(true);
            setSummaryModal(false)
            setLoading(false);
          });
      };
    
    const moveToCardPage = () => {
        props.handleScrollToAccordion3()
        props.handlePopupPurchaseLicenses()
    }

    const  closeCheckoutModal = () => {
        setCheckoutModal(false)
        setSummaryModal(false)
    }

    const backToLicensesPage  = () => {
        setSummaryModal(false)
    }

    const onChangeNumber = (id:any, event:any) => {
        const newItems = licensesData.map((item:any) => {
            if (item._id === id) {
                return { ...item, quantity: event.target.value };
            }
            return item;
        });
        setLicensesData(newItems);
    };

    const confirmPlan = () => {
        props.fetchDefaultLicenses()
       props.handlePopupPurchaseLicenses()

    }

    var data:any = []
    licensesData?.map((item:any) => {
        if(item?.quantity){
            var obj = {
                licenseId:item?._id,
                quantity:item?.quantity
            }
            data.push(obj)
        }         
    })
    return (
        <div style={{margin:"10px",width:"96%"}}>
        <Grid container spacing={2}>
          {loading ? (
            <Grid item md={12} style={{ textAlign: 'center' }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }}>
                <CircularProgress />
              </Box>
            </Grid>
          ) : summaryModal ? (
            <Grid container spacing={2}>
            <Grid item md={12} lg={12} sm={12} className={classes.borderBox}>
              <Grid item md={12} sm={12}>
                <Typography className={classes.licenseHeading}>Payment Summary</Typography>
                <Typography className={classes.typography} style={{ marginTop: '10px', marginBottom: '10px' }}>
                  Billing Interval: {summaryData?.billingInterval}
                </Typography>
              </Grid>
              <Grid item md={12} sm={12} style={{ marginBottom: '10px' }}>
                <Typography className={classes.licenseHeading}>New Licenses X {summaryData?.totalLicense}</Typography>
              </Grid>
              {summaryData?.items.map((item:any) => (
                <Grid item md={12} sm={12} className={classes.simpleFlex}>
                  <Grid item md={6} sm={6}>
                    <Typography className={classes.typography} style={{ color: 'black' }}>
                      {item?.licenseName} x {item?.quantity}
                    </Typography>
                    <Typography className={classes.typography}>
                      {item?.currencyCode}${item?.cost}x{item?.quantity} licenses x {item?.billingInterval}
                    </Typography>
                  </Grid>
                  <Grid item md={6} sm={6} style={{ textAlign: 'end' }}>
                    <Typography className={classes.typography}>{item?.currencyCode}${item?.totalCost}</Typography>
                  </Grid>
                </Grid>
              ))}
              <Divider className={classes.divider} style={{ marginTop: '18px', marginBottom: '13px' }} />
              <Grid item md={12} sm={12} className={classes.simpleFlex}>
                <Grid item md={6} sm={6}>
                  <Typography className={classes.typography} style={{ color: 'black' }}>
                    *New monthly total
                  </Typography>
                </Grid>
                <Grid item md={6} sm={6} style={{ textAlign: 'end' }}>
                  <Typography className={classes.typography} style={{ color: 'black' }}>{summaryData?.total}</Typography>
                  <Typography className={classes.typography}>(+ taxes and fees)</Typography>
                </Grid>
              </Grid>
              <Divider className={classes.divider} style={{ marginTop: '18px', marginBottom: '13px' }} />
              <Grid item md={12} sm={12} className={classes.simpleFlex}>
                <Grid item md={6} sm={6}>
                  <Typography className={classes.licenseHeading}>Total due Today</Typography>
                </Grid>
                <Grid item md={6} sm={6} style={{ textAlign: 'end' }}>
                  <Typography className={classes.licenseHeading}>{summaryData?.total}</Typography>
                  <Typography className={classes.typography}>(+ taxes and fees)</Typography>
                </Grid>
              </Grid>
              <Grid item md={12} sm={12} className={classes.simpleFlex} style={{ marginTop: '18px', marginBottom: '13px' }}>
                <Grid item md={12} sm={12}>
                  <Typography className={classes.typography}>{summaryData?.summaryDesc}</Typography>
                </Grid>
              </Grid>
            </Grid>
                   <Grid item md={12} sm={12} className={classes.flexEnd}>
                   <div className={classes.bttns}  style={{display:"flex",gap:"10px"}}>
                    <Button size="medium" className={classes.cancelButton} onClick={backToLicensesPage}>Back</Button>
                       <Button size="medium" className={classes.SaveButton} onClick={confirmCheckout}>confirm Purchase</Button>
                   </div>
               </Grid>
               </Grid>

          ) : checkoutModal ? (
            <Grid item md={12} style={{ textAlign: 'center' }}>
              <>
                <Typography variant="h6" style={{ textAlign: 'center', marginTop: '20px', color: '#2645ad', fontWeight: 700 }}>
                  Thank you for purchasing the licenses!
                </Typography>
                <Button size="medium" className={classes.SaveButton} style={{ marginTop: '40px' }} onClick={confirmPlan}>
                  Check your current Plan
                </Button>
              </>
            </Grid>
          ) : errorModal ? (
            <Grid item md={12} style={{textAlign:"center"}}>
              <Typography variant="h6" style={{ textAlign: 'center', marginTop: '20px', color: 'red', fontWeight: 700 }}>
                You cannot purchase licenses. Firstly, you need to add a card for purchasing licenses.
              </Typography>
              <Button size="medium" className={classes.SaveButton}
              style={{ marginTop: '40px' }} 
              
              onClick={moveToCardPage}>Ok</Button>
            </Grid>
          ) : (
            <Grid container spacing={2}>
            <div id="confirmation-modal" style={{ fontSize: "15px",fontWeight:700 }}>
                   Licenses scheduled for removal will be restored before purchasing new licenses.
               </div>
           <Grid item md={12} sm={12} className={classes.flex} style={{ justifyContent: "space-between",marginTop:"50px" }}>
               <Grid item md={6} sm={6}>
                   <Typography className={classes.licenseHeading}>License Type</Typography>
               </Grid>
               <Grid item md={6} sm={6} style={{ textAlign: "end" }}>
                   <Typography className={classes.licenseHeading}># To Be Purchased</Typography>
               </Grid>
           </Grid>

           {loading ? (
               <Box sx={{ display: 'flex', marginTop: "25px", marginLeft: "360px" }}>
                   <CircularProgress />
               </Box>
           ) : (
           licensesData?.map((item:any) => {
               return(
                   <Grid item md={12} sm={12}  style={{ display:"flex",justifyContent: "space-between" }}>
                   <Grid item md={6} sm={6}>
                       <Typography className={classes.licenseHeading}>{item?.licenseName}</Typography>
                       <Typography>{item?.currency}${item?.cost}/{item?.billingInterval === "Monthly" ? "mo" : "year"} per license</Typography>
                   </Grid>
                   <Grid item md={6} sm={6} style={{ textAlign: "end" }}>
                   <TextField
                               fullWidth
                               size="small"
                               type="number"
                               style={{width:"33%"}}
                               name="quantity"
                               variant="outlined"
                               value={item.quantity || ''}
                               onChange={(event) => onChangeNumber(item._id, event)}
                           />
                   </Grid>
               </Grid>
               )
           })
           )}
           {data.length > 0 &&
           <Grid item md={12} sm={12} className={classes.flexEnd}>
               <div className={classes.bttns}>
                   {/* <Button size="medium" className={classes.cancelButton}>Back</Button> */}
                   <Button size="medium" className={classes.SaveButton} onClick={SummaryLicenses}>Next</Button>
               </div>
           </Grid>}
       </Grid>
          )}
        </Grid>
        </div>
      );
   

    
}

export default AddLicenses;
